import React from 'react'
import './SectionOne.css'
function SectionOne() {
    const buttons = [
        {
            src: "/section-one/road-map.png",
            link: "#road-map"
        },
        {
            src: "/section-one/faq.png",
            link: "#faq"
        },
        {
            src: "/section-one/mint.png",
            link: "#mint"
        },
        {
            src: "/section-one/stake.png",
            link: "#stake"
        },
    ]
    const icons = [
        {
            src: "/section-one/twitter.png",
            link: ""
        },
        {
            src: "/section-one/hat.png",
            link: ""
        },
        {
            src: "/section-one/ship.png",
            link: ""
        }
    ]
    return (

        <div className='first-section-body'>
            <img src='/section-one/first-section.png'
                className='first-section-image'
            />
            <div className='section-one-top-bar-div'>
                <img src='/section-one/logo.png'
                    className='first-section-top-bar-icon'
                />
                {buttons.map((item, index) => {
                    return <a key={index} href={item.link}>
                        <img src={item.src}
                            style={{ paddingTop: index === 2 ? '4px' : '0px' }}
                            className='first-section-common-button' />
                    </a>
                })
                }
                <div className='section-one-top-bar-icons-div'>
                    {
                        icons.map((item, index) => {
                            return <a href={item.link} key={index} >
                                <img src={item.src}
                                    className='first-section-top-bar-icons' />
                            </a>
                        })
                    }
                </div>
                <img src='/section-one/wallet.png'
                    className='first-section-top-bar-banner' />
            </div>


        </div>
    )
}

export default SectionOne